/************************************************************
 GlobalConstants Namespace
 ************************************************************/

 window.globalConstants = {
    /*WORKFLOWS*/
    WF_REQUISITION_ORDER: 49,
    WF_PHYSIOTHERAPY_PRESCRIPTION: 50,
    WF_APPOINTMENT: 1,
    WF_EXTERIOR_PRESCRIPTION: 29,
    WF_EXTERIOR_PRESCRIPTION_GROUP: 30,
    WF_DENTAL_MEDICINE_MEDICAL_ACT: 52,
    WF_EPISODE: 2,
    WF_DENTAL_MEDICINE_PENDING_STATE: 20,
    WF_DENTAL_MEDICINE_CANCEL_STATE: 3,
    WF_DENTAL_MEDICINE_EXECUTE_STATE: 4,
    WF_OCCUPATIONAL_MEDICINE_EPISODE: 38,
    WF_OCCUPATIONAL_MEDICINE_APPOINTMENT: 53,
    WF_CONSULT_PROCESS: 43,
    WF_SMAP_CONSULT: 44,
    WF_CONTINUOUS_CARE: 56,
    WF_MCDT: 55,
    WF_EPISODE_MCDT: 57,
    WF_HCP_PLANS: 54,
    WF_HCP_PORTAL: 58,
    WF_HCP_PROCEDURES: 59,
    WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCESS: 60,
    WF_HCP_REIMBURSEMENT_MANAGEMENT_PROCEDURES: 61,
    WF_HCP_REIMBURSEMENT_MANAGEMENT_REQUEST_PROCESS: 62,
    WF_HCP_CLAIMS: 67,

    /*ACTIONS*/
    ACTION_VIEW_TASK_DETAILS_CLOSE_MODAL: -2,
    ACTION_UNDO_START_EPISODE: 99,
    ACTION_UNDO_FINALIZE_EPISODE: 100,
    ACTION_FINALIZED_CONSULT_SMAP: 5,
    ACTION_FINALIZE_EPISODE: 5,
    ACTION_PRINT_MFR_PRESCRIPTION: 111,
    ACTION_SCHEDULE_APPOINTMENT: 6,
    ACTION_PRINT_REQUISITION_ORDER: 23,
    ACTION_CANCEL: 3,
    ACTION_EDIT: 36,
    ACTION_MEDICAL_ACT_DENTAL_MEDICINE_CANCEL: 115,
    ACTION_MEDICAL_ACT_DENTAL_MEDICINE_SCHEDULE: 113,
    ACTION_MEDICAL_ACT_DENTAL_MEDICINE_EXECUTE: 114,
    ACTION_FINALIZE: 12,
    ACTION_DISCONTINUE: 8,
    ACTION_JUSTIFY_ABSENCE: 74,
    ACTION_UNDO_WEARER_ARRIVE: 17,
    ACTION_UNDO_START_ADMINISTRATIVE_SERVICE: 109,
    ACTION_UNDO_FINALIZE_ADMINISTRATIVE_SERVICE: 110,
    ACTION_RESCHEDULE_APPOINTMENT: 2,
    ACTION_BLOOD_RETURNED: 58,
    ACTION_BLOOD_TRANSFER: 52,
    ACTION_PRINT_EXAM_DELIVERABLE_TICKET: 125,
    ACTION_ASSOCIATED_RESULT: 126,
    ACTION_DELIVERY_RESULT: 127,
    ACTION_PRINT_PROCESS_DELIVERABLE_TICKET:157,
    ACTION_HCP_PROCEDURE_ELEGIBILITY_APOVE: 151,
    ACTION_HCP_PROCEDURE_ELEGIBILITY_REJECT: 152,
    ACTION_START_EPISODE: 4,


    /*STATUS*/
    STATUS_PRESCRIBED: 96,
    STATUS_SLOT_OCCUPIED: 108,
    STATUS_SLOT_PLANNED: 107,
    STATUS_SLOT_AVAILABLE: 40,
    STATUS_HCP_PROCEDURE_REQUESTED: 130,
    STATUS_HCP_REIMBURSEMENT_PROCEDURE_OPEN: 139,
    STATUS_HCP_OPINIONS_PENDING: 165,

    /*DENTAL MEDICINE*/
    CURRENT_STATE:1,
    INITIAL_STATE: 2,
    CANCEL_DEFECT: 999,
    ODONTOGRAM_ADULT_TYPE:1,
    ODONTOGRAM_CHILD_TYPE:2,
    BODY_ELEMENT_TYPE_DENTAL_DEFECT_TYPE: 'DentalDefectType',
    BODY_ELEMENT_TYPE_DENTAL_TREATMENT_TYPE: 'DentalTreatmentType',
    DENTAL_DEFECT_CLICK_TYPE_HIDDEN: 'hidden',
    DENTAL_DEFECT_CLICK_TYPE_DEFAULT: 'fill',

    /* CLINICAL_TEMPLATE - TEMPLATE_ITEM_TYPE : CODE */
    CLINICAL_TEMPLATE_ITEM_TYPE_CODE_INPUT_VALUE: 'INPUT_VALUE',
    CLINICAL_TEMPLATE_ITEM_TYPE_CODE_SELECT_OPTION: 'SELECT_OPTION',
    CLINICAL_TEMPLATE_ITEM_TYPE_CODE_TEXT_AREA: 'TEXT_AREA',
    CLINICAL_TEMPLATE_ITEM_TYPE_CODE_RADIO_BUTTON: 'RADIO_BUTTON',

    /* CLINICAL_TEMPLATE - TEMPLATE_TYPE : CODE */
    CLINICAL_TEMPLATE_TYPE_CODE_QUESTIONAIRE: 'QUESTIONAIRE',

    /* CLINICAL_TEMPLATE - TEMPLATE_ITEM_TYPE : CODE */
    CLINICAL_TEMPLATE_SCORING_TYPE_SUM: 1,
    CLINICAL_TEMPLATE_SCORING_TYPE_AVG: 2,
    CLINICAL_TEMPLATE_SCORING_TYPE_AVG_WIHT_SECTIONS: 3,

    /* DATEPICKER */

    MINIMUM_YEAR: 1000,

    /*APPOINTMENT TYPE*/
    APPOINTMENT_TYPE_SMAP: 16,
    APPOINTMENT_TYPE_EXAM: 6,

    //Treatment Type
    TREATMENT_TYPE_MISHAP: 2,
    TREATMENT_TYPE_MCDT: 9,

    //* WF ACTION PARAMS TYPE *//
    WF_ACTION_TYPE_LOAD_SHORTCUT: 'load_shortcut',
    WF_ACTION_TYPE_LOAD_MODAL: 'load_modal',

    LOAD_MEDICAL_ACTS: 'load_medical_acts',
    INSERT_MEDICAL_ACTS: 'insert_medical_acts',
    LOAD_DEFAULT_MEDICAL_ACTS: 'load_default_medical_acts',

    LOAD_EQUIPMENTS_LIST: 'load_equipments_list',


    /********************************************************
     * DOC_TYPE
     ********************************************************/
    DOC_TYPE_CREDENTIAL: 15,
    DOC_TYPE_BUDGET: 17,
    DOC_TYPE_INVOICE: 1,

    /********************************************************
    * ORIGIN_TYPE (table origin)
     ********************************************************/
    ORIGIN_TYPE_CREDENTIAL: 10,
    ORIGIN_TYPE_BUDGET: 13,

    PROCCESS_ACTION_TYPE_REOPEN: 'REOPEN',
    PROCCESS_ACTION_TYPE_FINALIZE: 'FINALIZE',

    PROCCESS_CONTEXT_TYPE_P1: 'P1',
    PROCCESS_CONTEXT_TYPE_DEFAULT: 'DEFAULT',

    /********************************************************
     * REPORT PRINTING TYPE
     ********************************************************/

    REPORT_BILLING_PRINT_TYPE_ORIGINAL: 1,
    REPORT_BILLING_PRINT_TYPE_DUPLICATE: 2,
    REPORT_BILLING_PRINT_TYPE_TRIPLICATE: 3,
    REPORT_BILLING_PRINT_TYPE_QUADRUPLICATE: 4,
    REPORT_BILLING_PRINT_TYPE_SECOND_COPY: 5,

    /********************************************************
     * SOFTWARE
     ********************************************************/

    SOFTWARE_CONTINUOUS_CARE: 19,

    /********************************************************
     * ADVANCED SCHEDULE
     ********************************************************/

    ADVANCED_SCHEDULE_PROFESSIONAL_TYPE: 'professional',
    ADVANCED_SCHEDULE_ITEM_TYPE: 'item',
    ADVANCED_CALENDAR: 2,
    NORMAL_CALENDAR: 1,

    /********************************************************
     * ADVANCED SCHEDULE
     ********************************************************/

    ADVANCED_CALENDAR_TYPE_CALENDAR: 1,
    ADVANCED_CALENDAR_TYPE_LIST: 2,

    /********************************************************
     * ITEM TYPE
     ********************************************************/

    CONSUMABLE: 1,
    MEDICATION_PACKAGE: 9,

    /********************************************************
     * NOTIFICATION TYPE (EMAIL,SMS) - QUEUE PERSISTENCE
     ********************************************************/

    EXTERNAL_NOTIFICATION_APPOINTMENT: 'APPOINTMENT_SCHEDULE',
    EXTERNAL_NOTIFICATION_INVOICE_CREATED: 'INVOICE_CREATED',
    EXTERNAL_NOTIFICATION_RSP_PRESCRIPTION_CREATED: 'RSP_PRESCRIPTION_CREATED',
    EXTERNAL_NOTIFICATION_MCDT_PRESCRIPTION_CREATED: 'MCDT_PRESCRIPTION_CREATED',
    EXTERNAL_NOTIFICATION_ANALYSIS_PRESCRIPTION_CREATED: 'ANALYSIS_PRESCRIPTION_CREATED',

    /********************************************************
     * INTEGRATION TYPE - QUEUE PERSISTENCE
     ********************************************************/

    APPOINTMENT_INTEGRATION: 'APPOINTMENT_SCHEDULE',
    PROFESSIONAL_INTEGRATION: 'PROFESSIONAL_INTEGRATION',
    PROFESSIONAL_CALENDAR_INTEGRATION: 'PROFESSIONAL_CALENDAR_INTEGRATION',
    PROFESSIONAL_RESERVATION_INTEGRATION: 'PROFESSIONAL_RESERVATION_INTEGRATION',
    PROFESSIONAL_VACATIONS_INTEGRATION: 'PROFESSIONAL_VACATIONS_INTEGRATION',


    /********************************************************
     * PARTY_TYPE
     ********************************************************/

    PARTY_TYPE_CLINICAL: 2,
    PARTY_TYPE_FINANCIAL_ENTITY: 3,

    /********************************************************
     * SYS_CONFIS_CODE
     ********************************************************/

    AUTOMATIC_EPISODE_BILLING: 'ENABLE_AUTOMATIC_EPISODE_BILLING',
    ENABLE_PATIENT_VALIDATION_DATA: 'ENABLE_PATIENT_VALIDATION_DATA',

    /********************************************************
     * SHORTCUT
     ********************************************************/

    SHORTCUT_VIEW_PATIENT: 101,

    /********************************************************
     * REPORT
     ********************************************************/

    INPATIENT_DISCHARGE_NOTE_REPORT: 186,
    INPATIENT_NURSING_DISCHARGE_REPORT: 172,
    CLINICAL_DIARY_REPORT: 191,
    CLINICAL_NURSE_DIARY_REPORT: 302,

};